import { render, staticRenderFns } from "./support-message-demo.vue?vue&type=template&id=64b5de0f&scoped=true&"
import script from "./support-message-demo.vue?vue&type=script&lang=js&"
export * from "./support-message-demo.vue?vue&type=script&lang=js&"
import style0 from "./support-message-demo.vue?vue&type=style&index=0&id=64b5de0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5de0f",
  null
  
)

export default component.exports